import { v4 as uuidv4 } from 'uuid'

import GalleryOne from 'assets/images/gallery/galleryOne.webp'
import GalleryTwo from 'assets/images/gallery/galleryTwo.webp'
import GalleryThree from 'assets/images/gallery/galleryThree.webp'
import GalleryFour from 'assets/images/gallery/galleryFour.webp'
import GalleryFive from 'assets/images/gallery/galleryFive.webp'
import GallerySix from 'assets/images/gallery/gallerySix.webp'
import GallerySeven from 'assets/images/gallery/gallerySeven.webp'
import GalleryEight from 'assets/images/gallery/galleryEight.webp'

const galleryData = [
  {
    id: uuidv4(),
    url: GalleryOne,
  },
  {
    id: uuidv4(),
    url: GalleryTwo,
  },
  {
    id: uuidv4(),
    url: GalleryThree,
  },
  {
    id: uuidv4(),
    url: GalleryFour,
  },
  {
    id: uuidv4(),
    url: GalleryFive,
  },
  {
    id: uuidv4(),
    url: GallerySix,
  },
  {
    id: uuidv4(),
    url: GallerySeven,
  },
  {
    id: uuidv4(),
    url: GalleryEight,
  },
]

export default galleryData
